import { gql } from '../gen';

export const AUTH_STATUS = gql(`
  query AuthStatus {
    authStatus {
      isAuthenticated
      email
      isSponsor
    }
  }
`);

export const ME = gql(`
  query Me {
    me {
      id
      email
      firstName
      lastName
      isAdmin
      profileImageUrl
      hasFamilyTreeProfileConsent
      mdiOnboardingStartedAt
      mdiOnboardingCompletedAt
      memberships {
        id
        role
        treeId
        tree {
          id
          name
          ownerId
          owner {
            id
            firstName
            lastName
            profileImageUrl
          }
        }
      }
      ownedTree {
        id
        name
        ownerId
        createdAt
        updatedAt
        persons {
          id
          firstName
          lastName
          geneticSex
          birthDate
          deathDate
          userId
          profileImageUrl
          partnerInFamilies {
            id
            status
            startDate
            endDate
            partners {
              id
              firstName
              lastName
              geneticSex
            }
            children {
              id
              firstName
              lastName
              geneticSex
            }
          }
          childInFamilies {
            id
            status
            partners {
              id
              firstName
              lastName
              geneticSex
            }
          }
        }
        families {
          id
          status
          startDate
          endDate
          familyTreeId
          createdAt
          updatedAt
          partners {
            id
          }
          children {
            id
          }
        }
      }
    }
  }
`);

export const GET_MDI_ONBOARDING_URL = gql(`
  query GetMdiOnboardingUrl {
    getMdiOnboardingUrl
  }
`);

export const GET_ONBOARDING_STATUS = gql(`
  query OnboardingStatus {
    onboardingStatus {
      userExists
      consentAcknowledged
      completed
      riskTier
      hasDeclinedInvitation
    }
  }
`);

export const GENERATE_CLOUDINARY_SIGNATURE = gql(`
  query GenerateCloudinarySignature {
    generateCloudinarySignature {
      signature
      timestamp
      cloudName
      apiKey
      folder
    }
  }
`);

export const GET_INVITATION_DETAILS = gql(`
  query GetInvitationDetails($token: String!) {
    getInvitationDetails(token: $token) {
      id
      token
      email
      status
      treeId
      treeName
      personId
      personFirstName
      personLastName
      invitedById
      inviterFirstName
      inviterLastName
    }
  }
`);

export const GET_EDITOR_PERSON_DATA = gql(`
  query GetEditorPersonData($treeId: Int!) {
    getEditorPersonData(treeId: $treeId) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      profileImageUrl
    }
  }
`);

export const GET_FAMILY_TREE = gql(`
  query GetFamilyTree($familyTreeId: Int!) {
    getFamilyTree(familyTreeId: $familyTreeId) {
      id
      name
      ownerId
      createdAt
      updatedAt
      persons {
        id
        firstName
        lastName
        geneticSex
        birthDate
        deathDate
        userId
        profileImageUrl
        partnerInFamilies {
          id
          status
          startDate
          endDate
          partners {
            id
            firstName
            lastName
            geneticSex
          }
          children {
            id
            firstName
            lastName
            geneticSex
          }
        }
        childInFamilies {
          id
          status
          partners {
            id
            firstName
            lastName
            geneticSex
          }
        }
      }
      families {
        id
        status
        startDate
        endDate
        familyTreeId
        createdAt
        updatedAt
        partners {
          id
        }
        children {
          id
        }
      }
    }
  }
`);

export const GET_INVITATION_BY_PERSON_ID = gql(`
  query GetInvitationByPersonId($personId: Int!) {
    getInvitationByPersonId(personId: $personId) {
      id
      email
      status
      createdAt
      acceptedAt
    }
  }
`);

export const SEARCH_COHORT_ENTRIES = gql(`
  query SearchCohortEntries($input: SearchCohortEntriesInput!) {
    searchCohortEntries(input: $input) {
      totalCohortSize
      filtersApplied
      censusRegion {
        value
        count
        percent
      }
      ageBand {
        value
        count
        percent
      }
      sex {
        value
        count
        percent
      }
      raceEthnicity {
        value
        count
        percent
      }
      geneSymbol {
        value
        count
        percent
      }
      testType {
        value
        count
        percent
      }
      labSource {
        value
        count
        percent
      }
      inheritancePattern {
        value
        count
        percent
      }
      diagnoses {
        value
        count
        percent
      }
      keySymptoms {
        value
        count
        percent
      }
      keyLabs {
        value
        count
        percent
      }
      onsetType {
        value
        count
        percent
      }
      treatmentExposure {
        value
        count
        percent
      }
      yearOfSample {
        value
        count
        percent
      }
    }
  }
`);
